import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { getRequest } from "../../api";
import "./confirmEmailMobile.css";

const ConfirmEmailMobile = () => {
  const [loader, setLoader] = useState(true);
  const [confirmationStatus, setConfirmationStatus] = useState(null);

  const confirmEmailRequest = async (token) => {
    setLoader(true);
    try {
      await getRequest(`/api/v2/user/confirm-email?token=${token}`);

      setConfirmationStatus("success");
      setLoader(false);
    } catch (error) {
      setConfirmationStatus("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      confirmEmailRequest(token);
    }
  }, []);

  return (
    <div className="confirm-email-mobile-container">
      {loader ? (
        <div className="loader-container">
          <Spin size="large" />
        </div>
      ) : confirmationStatus === "success" ? (
        <div className="confirmation-message">
          <h1>Email Confirmed</h1>
          <p>
            Your email has been confirmed. You can now continue on the mobile
            app.
          </p>
        </div>
      ) : (
        <div className="confirmation-message">
          <h1>Error</h1>
          <p>
            There was an issue confirming your email. Please try again later.
          </p>
        </div>
      )}
    </div>
  );
};

export default ConfirmEmailMobile;
